import { ConfigService } from 'app/Core/Abstract/config.service';
import { Component, OnInit } from "@angular/core";
import { DecimalPipe, DatePipe } from "@angular/common";
import { UntypedFormBuilder, UntypedFormGroup, Validators, UntypedFormControl } from "@angular/forms";
import { throwError } from "rxjs";
import { BaseCRUDComponent } from "../../../Core/Abstract/baseCRUD.component";
import { EventsEmitterService } from "../../../Core/Abstract/emitter.service";
import { LogService } from "../../../Core/Abstract/log.service";
import { VisualsService } from "../../../Core/Abstract/visuals.service";
import { ActivatedRoute, Router } from "@angular/router";
import { ContactUsService } from "./contactUs.service"
import { Location } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { ReCaptchaV3Service } from 'ng-recaptcha';
import { SecurityService } from '../../../Core/Security/security.service';

@Component({
  selector: "contactUs-grid",
  templateUrl: "./contactUs.component.html",
  styleUrls: ["./contactUs.component.css"],
  providers: [ContactUsService, DecimalPipe, DatePipe]
})    
export class ContactUsComponent extends BaseCRUDComponent<ContactUsService> implements OnInit {

    protected loading: boolean = false;
    captcha: any;
    private contactForm: UntypedFormGroup;
    isLoggedIn: any;
    mobileCode:any;
    buyerCmpNm: any;
    submitting: boolean = false;
    countryCodesList = [];
    selected:any;
    footerMsg = "";
    protected profile: string = 'demo';

    ngOnInit(): void {
      this.getCountryCodesList()
      this.buyerCmpNm = localStorage.getItem("byuerName")
      if (this.securityService.getFromStorage("access_token") === null){
        this.isLoggedIn = false
      }
      else{
        this.isLoggedIn = true
        
      }
        this.buildForm();
        this.footerMsg = this.configService.getFooter();
    }
    getCountryCodesList(){
      this.service.getCountryCodesList("1")
      .subscribe(
        data => {
            this.countryCodesList = data;
        },
        error => {
          this.logger.info(error);
        }
      );
  }
  selectEvent(item) {
    this.contactForm.controls['mobileCode'].setValue(item.val);
      this.mobileCode = item.val
  }
    goBack() {
      this.location.back(); 
    } 
    mailTo
    placeHolderMobileCode
  constructor(
    private service: ContactUsService,
    private location: Location,
    private eventsEmitterService: EventsEmitterService,
    fb: UntypedFormBuilder,
    logger: LogService,
    visualsService: VisualsService,
    route: ActivatedRoute,
    router: Router,
    private translate: TranslateService, 
    private configService: ConfigService,
    private recaptchaV3Service: ReCaptchaV3Service,
    protected securityService: SecurityService
  ) {
    super(logger, visualsService, route, fb, router);
    translate.get('CONTACT_US.MAILTO').subscribe(s =>{
      this.mailTo = s
    })
    translate.get('CONTACT_US.ENTERMOBILECODE').subscribe(s =>{
      this.placeHolderMobileCode = s
    }
    );
    this.profile = this.configService.getClient();
  }

  buildForm(){
    this.contactForm = new UntypedFormGroup({
        name: new UntypedFormControl('',Validators.pattern(this.alpha)),
        mobileCode: new UntypedFormControl(''),
        supplierCmpNm: new UntypedFormControl('',[Validators.required]),
        fromEmail: new UntypedFormControl('',[Validators.required,Validators.pattern(this.email)]),
        contactNum: new UntypedFormControl('',Validators.pattern(this.nonalpha)),
        content: new UntypedFormControl('',[Validators.required]),
        captcha: new UntypedFormControl(this.captcha,[])
      })
}
updateCodeValidity(){
if(this.contactForm.controls.contactNum.value){
  this.contactForm.controls.mobileCode.setValidators(Validators.required)
}
else{
  this.contactForm.controls.mobileCode.setValidators(null)
}
this.contactForm.controls.mobileCode.updateValueAndValidity()
}

onSubmit(){
  this.submitting = true; 
  if(this.contactForm.valid){
    this.loading = true;
    this.recaptchaV3Service.execute('contactus').subscribe({
      next : (token: string) => {
        this.contactForm.value.contactNum = this.contactForm.value.mobileCode + this.contactForm.value.contactNum
        if(this.isLoggedIn){
          this.contactForm.value.buyerCmpNm = this.buyerCmpNm
        }
        this.captcha = token
        this.contactForm.controls.captcha.setValue(token);
        this.service.submitContactForm(this.contactForm.value).subscribe({
          next : (data) => {
            this.contactForm.reset()
            this.loading = false;
            this.submitting = false; 
            LogService.emitAlert({
              type: "success",
              body: "Success"
            });
          },
          error : (error) => {
            this.captcha = '';
            this.contactForm.controls.captcha.setValue(null)
            this.loading = false;
            this.submitting = false; 
            console.error(error);
            LogService.emitAlert({
              type: "error",
              body: error.error.message
            });
            return throwError(error);
          }
        });
      },
      error : (error) => {
        this.captcha = '';
        this.contactForm.controls.captcha.setValue(null)
        this.loading = false;
        this.submitting = false; 
        console.error(error);
        LogService.emitAlert({
          type: "error",
          body: error.error.message
        });
        return throwError(error);
      }
    });
  }
}
}

